export enum TransactionType {
Income,
Expense,
Accounting,
}
